import React, { Fragment, useState, useEffect, useContext, useCallback } from "react";
import { useParams } from "react-router-dom";
import { ProductDetailsContext } from "./index";
import { LayoutContext } from "../layout";
import Submenu from "./Submenu";
import ProductDetailsSectionTwo from "./ProductDetailsSectionTwo";
import { getSingleProduct } from "./FetchApi";
import { cartListProduct } from "../partials/FetchApi";
import { isWishReq, unWishReq, isWish } from "../home/Mixins";
import { updateQuantity, addToCart, cartList } from "./Mixins";
import { totalCost } from "../partials/Mixins";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faShippingFast,faBox } from "@fortawesome/free-solid-svg-icons";

const apiURL = process.env.REACT_APP_API_URL;

const ProductDetailsSection = () => {
  const { id } = useParams();
  const { data, dispatch } = useContext(ProductDetailsContext);
  const { data: layoutData, dispatch: layoutDispatch } = useContext(LayoutContext);
  const [wishlist, setWishlist] = useState(JSON.parse(localStorage.getItem("wishList")) || []);
  const product = layoutData.singleProductDetail;

  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [, setQuantityAlert] = useState(false);
  const [zipCode, setZipCode] = useState(() => {
    const savedZip = localStorage.getItem("zipCode");
    return savedZip || "";
  });
  const [shippingOptions, setShippingOptions] = useState([]);
  const [loadingShipping, setLoadingShipping] = useState(false);
  const [shippingError, setShippingError] = useState("");
  const [selectedShipping, setSelectedShipping] = useState(null);

  useEffect(() => {
    localStorage.setItem("zipCode", zipCode);
  }, [zipCode]);

  useEffect(() => {
    const savedShipping = localStorage.getItem("selectedShipping");
    if (savedShipping) {
      try {
        setSelectedShipping(JSON.parse(savedShipping));
      } catch (error) {
        console.error("Error parsing saved shipping:", error);
      }
    }
  }, []);

  useEffect(() => {
    const cleanZip = zipCode.replace(/\D/g, "");
    if (/^\d{8}$/.test(cleanZip)) {
      calculateShipping();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const formatZipCode = (value) => {
    const cleanValue = value.replace(/\D/g, "").slice(0, 8);
    if (cleanValue.length > 5) return `${cleanValue.slice(0, 5)}-${cleanValue.slice(5)}`;
    return cleanValue;
  };

  const calculateShipping = async () => {
    setShippingError("");
    setSelectedShipping(null);
    const cleanZipCode = zipCode.replace(/\D/g, "");
    
    if (!/^\d{8}$/.test(cleanZipCode)) {
      setShippingError("Por favor, insira um CEP válido com 8 dígitos");
      return;
    }

    try {
      setLoadingShipping(true);
      const response = await fetch(`${apiURL}/frete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cepDestino: cleanZipCode }),
      });

      if (!response.ok) throw new Error("Erro ao buscar opções de entrega");

      const data = await response.json();
      if (data.length) {
        setShippingOptions(data);
        const savedShipping = localStorage.getItem("selectedShipping");
        if (savedShipping) {
          try {
            const parsedShipping = JSON.parse(savedShipping);
            const existingOption = data.find(
              option => option.servico === parsedShipping.servico &&
                        option.transportadora === parsedShipping.transportadora &&
                        option.preco === parsedShipping.preco
            );
            if (existingOption) setSelectedShipping(existingOption);
          } catch (error) {
            console.error("Error parsing saved shipping:", error);
          }
        }
      } else {
        setShippingOptions([]);
        setShippingError("Nenhuma opção de entrega disponível para este CEP");
      }
    } catch (error) {
      console.error("Erro no cálculo do frete:", error);
      setShippingError("Não foi possível calcular o frete. Tente novamente.");
    } finally {
      setLoadingShipping(false);
    }
  };

  const fetchCartProducts = useCallback(async () => {
    try {
      const response = await cartListProduct();
      if (response?.Products) {
        layoutDispatch({ type: "cartProduct", payload: response.Products });
      }
    } catch (error) {
      console.error("Erro ao carregar carrinho:", error);
    }
  }, [layoutDispatch]);

  const fetchProduct = useCallback(async () => {
    dispatch({ type: "loading", payload: true });
    try {
      const response = await getSingleProduct(id);
      if (response.Product) {
        layoutDispatch({ 
          type: "singleProductDetail", 
          payload: response.Product 
        });
        layoutDispatch({ 
          type: "inCart", 
          payload: cartList() 
        });
      }
      dispatch({ type: "loading", payload: false });
    } catch (error) {
      console.error("Erro ao carregar produto:", error);
      dispatch({ type: "loading", payload: false });
    }
    fetchCartProducts();
  }, [id, dispatch, layoutDispatch, fetchCartProducts]);

  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]);

  if (data.loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-500"></div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="text-center py-20">
        <h2 className="text-xl text-gray-600">Produto não encontrado</h2>
        <p className="text-gray-500 mt-2">O produto solicitado não está disponível no momento</p>
      </div>
    );
  }

  const averageRating = product.pRatingsReviews && product.pRatingsReviews.length > 0
  ? (product.pRatingsReviews.reduce((acc, curr) => acc + curr.rating, 0) / product.pRatingsReviews.length)
  : 0;

  return (
    <Fragment>
      <Submenu
        value={{
          categoryId: product.pCategory._id,
          product: product.pName,
          category: product.pCategory.cName,
        }}
      />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Imagens do Produto */}
          <div className="lg:col-span-6 space-y-6">
    {/* Imagem Principal */}
    <div className="relative aspect-square bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl overflow-hidden shadow-2xl group">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-gray-900/30 to-transparent opacity-70 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <img
        className="w-full h-full object-contain p-10 transition-all duration-500 group-hover:scale-[1.02]"
        src={`${apiURL}/uploads/products/${product.pImages[activeImageIndex]}`}
        alt={`Visualização premium do produto ${product.pName}`}
      />
      
      {/* Badge de Destaque */}
      <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-500 to-orange-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
        DESTAQUE
      </div>
    </div>

    {/* Miniaturas */}
    <div className="relative">
      <div className="flex gap-3 overflow-x-auto pb-3 scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-900/20">
        {product.pImages.map((img, index) => (
          <button
            key={index}
            onClick={() => setActiveImageIndex(index)}
            className={`shrink-0 relative w-20 h-20 rounded-xl overflow-hidden transition-all duration-300 transform ${
              activeImageIndex === index
                ? "ring-2 ring-amber-400 scale-105 shadow-lg"
                : "border-2 border-gray-700 hover:border-amber-400 hover:scale-100"
            }`}
          >
            {/* Overlay de destaque */}
            {activeImageIndex === index && (
              <div className="absolute inset-0 bg-amber-400/10 backdrop-blur-[1px]"></div>
            )}
            
            <img
              className="w-full h-full object-cover"
              src={`${apiURL}/uploads/products/${img}`}
              alt={`Miniatura ${index + 1}`}
            />
          </button>
        ))}
      </div>
      
      {/* Efeito de brilho nas bordas */}
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent"></div>
    </div>
  </div>

          {/* Informações do Produto */}
          <div className="lg:col-span-6">
            <div className="space-y-6">
{/* Cabeçalho com nome e wishlist clean e elegante */}
<div className="flex justify-between items-start">
  <div>
    <h1 className="text-2xl font-semibold text-neutral-800 tracking-tight">
      {product.pName}
    </h1>

    {/* Subtítulo opcional */}
    {product.pSubtitle && (
      <p className="text-neutral-500 mt-1 text-sm">{product.pSubtitle}</p>
    )}

    {/* Quantidade disponível com foguinho */}
    <div className="mt-2 flex items-center gap-1">
      <span className="text-sm font-medium text-orange-600">
        {product.pQuantity} unidades disponíveis
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-4 h-4 text-orange-500 animate-pulse"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M16.68 6.6c-1.23-.88-1.89-2.33-2.17-3.91-.05-.29-.34-.46-.62-.4-2.33.55-4.22 2.44-4.69 4.83-.14.73-.18 1.45-.12 2.13a.76.76 0 0 1-.73.83c-.91.04-1.8-.19-2.6-.63-.25-.14-.55.02-.61.29-.52 2.24.14 4.88 2.04 6.73A6.5 6.5 0 0 0 12 20a6.5 6.5 0 0 0 6.31-4.87c.75-2.38.05-5.64-1.63-8.53z" />
      </svg>
    </div>
  </div>

  {/* Botão coração */}
  <button
    onClick={(e) =>
      isWish(product._id, wishlist)
        ? unWishReq(e, product._id, setWishlist)
        : isWishReq(e, product._id, setWishlist)
    }
    className={`p-2 rounded-full border transition-colors duration-300 focus:outline-none focus:ring-0
      ${
        isWish(product._id, wishlist)
          ? "bg-red-500 border-red-500 text-white"
          : "border-red-500 text-red-500 hover:bg-red-50"
      }`}
    aria-label="Favoritar"
  >
    <svg
      className="w-5 h-5"
      fill={isWish(product._id, wishlist) ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="1.8"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733C11.285 4.876 9.623 3.75 7.687 3.75 5.099 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
      />
    </svg>
  </button>
</div>
              {/* Avaliações estilo Google */}
<div className="flex items-center space-x-2 text-sm text-gray-600">
  {/* Estrelas */}
  <div className="flex items-center space-x-0.5">
    {Array.from({ length: 5 }, (_, i) => (
      <FontAwesomeIcon
        key={i}
        icon={faStar}
        className={`w-4 h-4 ${
          i < Math.round(averageRating)
            ? "text-yellow-400"
            : "text-gray-300"
        }`}
      />
    ))}
  </div>

  {/* Nota e quantidade */}
  <span className="font-medium text-gray-800">
    {averageRating.toFixed(1)}
  </span>
  <span className="text-gray-400">({product.pRatingsReviews?.length || 0} avaliações)</span>
</div>

            {/* Preço */}
{/* Preço com cálculo de desconto automático */}
<div className="mt-4 space-y-1">
  <div className="flex items-baseline space-x-2">
    <span className="text-3xl font-bold text-green-600">
      {product.pPrice.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}
    </span>

    {product.pOffer > product.pPrice && (
      <>
        <span className="text-sm line-through text-red-500">
          {product.pOffer.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}
        </span>

        <span className="text-xs font-semibold bg-green-100 text-green-800 px-2 py-0.5 rounded-full">
          {Math.round(((product.pOffer - product.pPrice) / product.pOffer) * 100)}% OFF
        </span>
      </>
    )}
  </div>

  <div className="text-sm text-gray-700 mt-1">
    ou <strong className="text-green-700">
      {(product.pPrice / 3).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}
    </strong> em até 3x sem juros
  </div>
</div>
              {/* Descrição */}
             {/* Descrição */}
<div className="mt-4">
  <h3 className="text-lg font-semibold text-gray-900 mb-2">Descrição do Produto</h3>
  <div
    className="text-gray-600 leading-relaxed"
    dangerouslySetInnerHTML={{
      __html: product.pDescription || "Este produto não possui descrição detalhada.",
    }}
  />
</div>
             {/* Frete */}
<div className="mt-8 space-y-6">
  {/* Título e ícone */}
  <div className="flex items-center gap-2">
    <FontAwesomeIcon icon={faShippingFast} className="text-blue-500 w-5 h-5" />
    <h3 className="text-base font-semibold text-gray-800">Calcular frete</h3>
  </div>

  {/* Input + botão */}
  <div className="flex flex-col sm:flex-row gap-4">
    <input
      type="text"
      value={formatZipCode(zipCode)}
      onChange={(e) => setZipCode(e.target.value)}
      placeholder="Digite seu CEP"
      className="flex-1 px-4 py-3 border border-gray-300 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 focus:outline-none text-sm text-gray-800 placeholder-gray-400 transition-all"
      maxLength="9"
    />
    <button
      onClick={calculateShipping}
      disabled={loadingShipping}
      className={`w-full sm:w-auto px-6 py-3 rounded-xl text-sm font-semibold shadow-md transition-colors ${
        loadingShipping
          ? "bg-blue-200 text-blue-100 cursor-not-allowed"
          : "bg-blue-600 hover:bg-blue-700 text-white"
      }`}
    >
      {loadingShipping ? "Calculando..." : "Calcular frete"}
    </button>
  </div>

  {/* Erro de frete */}
  {shippingError && (
    <p className="text-sm text-red-500">{shippingError}</p>
  )}

  {/* Opções de entrega */}
  {shippingOptions.length > 0 && (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-gray-700">Opções de entrega</h4>
      {shippingOptions
        .sort((a, b) => a.preco - b.preco)
        .map((option, index) => (
          <div
            key={index}
            onClick={() => {
              setSelectedShipping(option);
              localStorage.setItem("selectedShipping", JSON.stringify(option));
            }}
            className={`p-4 rounded-xl border cursor-pointer transition-all shadow-sm group ${
              selectedShipping?.servico === option.servico
                ? "border-blue-500 bg-blue-50"
                : "border-gray-200 hover:border-blue-400 hover:bg-blue-50/30"
            }`}
          >
            <div className="flex justify-between items-center">
              <div className="space-y-1">
                <div className="flex items-center gap-2">
                  {option.transportadora.toLowerCase().includes("correios") && (
                    <span className="inline-flex items-center gap-1 border border-blue-400 text-blue-900 bg-white text-xs font-medium px-2 py-0.5 rounded-md">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width="16"
                        height="16"
                        className="text-blue-800"
                      >
                        <rect width="512" height="512" rx="15%" fill="#ffd100" />
                        <path
                          fill="#003d8f"
                          d="M145 160h77l-52 48 50 48h-76l-56-48zm139 0h77l-52 48 50 48h-76l-56-48zm-81 112 56 48-8 48h-59l-49-48h64zm114 0 56 48-8 48h-59l-49-48h64z"
                        />
                      </svg>
                      <span className="text-blue-600 font-semibold">Correios</span>
                    </span>
                  )}
                  <p className="text-sm font-medium text-gray-800 group-hover:text-blue-700">
                    {option.servico}
                  </p>
                </div>
                <p className="text-xs text-gray-500">
                  Entrega em {option.prazo} dias úteis
                </p>
              </div>
              <p className="text-base font-semibold text-green-600 group-hover:text-green-700">
                {Number(option.preco).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </p>
            </div>
          </div>
        ))}
    </div>
  )}
</div>
              {/* Quantidade e Adicionar ao Carrinho */}
            {selectedShipping && (
  <div className="mt-6 space-y-4">
    {/* Quantidade */}
    <div className="flex items-center justify-between border border-gray-200 p-3 rounded-lg bg-white shadow-sm">
      <span className="text-gray-700 font-medium">Quantidade</span>
      <div className="flex items-center gap-3">
        <button
          onClick={() => updateQuantity("decrease", product.pQuantity, quantity, setQuantity, setQuantityAlert)}
          className="p-2 rounded-full hover:bg-gray-100 text-gray-600 disabled:opacity-40"
          disabled={quantity === 1}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H4" />
          </svg>
        </button>
        <span className="w-8 text-center font-medium text-gray-900">{quantity}</span>
        <button
          onClick={() => updateQuantity("increase", product.pQuantity, quantity, setQuantity, setQuantityAlert)}
          className="p-2 rounded-full hover:bg-gray-100 text-gray-600 disabled:opacity-40"
          disabled={quantity === product.pQuantity}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v12m-6-6h12" />
          </svg>
        </button>
      </div>
    </div>

    {quantity === product.pQuantity && (
      <p className="text-sm text-red-500">Quantidade máxima disponível</p>
    )}

    {/* Totais */}
    <div className="p-4 bg-white rounded-lg border border-gray-200 shadow-sm space-y-3">
      <div className="flex justify-between text-gray-700 text-sm">
        <span>Subtotal</span>
        <span>{(product.pPrice * quantity).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
      </div>
      <div className="flex justify-between text-gray-700 text-sm">
        <span>Frete</span>
        <span>{Number(selectedShipping.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
      </div>
      <div className="flex justify-between pt-3 border-t border-gray-200 font-semibold text-base text-gray-900">
        <span>Total</span>
        <span className="text-blue-600">
          {(product.pPrice * quantity + Number(selectedShipping.preco)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
        </span>
      </div>
    </div>

    {/* Botão */}
    <button
      onClick={() => {
        localStorage.setItem("selectedShipping", JSON.stringify(selectedShipping));
        addToCart(
          product._id,
          quantity,
          product.pPrice,
          layoutDispatch,
          setQuantity,
          setQuantityAlert,
          fetchProduct,
          totalCost
        );
      }}
      className={`w-full py-3 rounded-md font-semibold text-white transition-colors ${
        layoutData.inCart?.includes(product._id) || product.pQuantity === 0 || !selectedShipping
          ? "bg-gray-100 text-gray-400 cursor-not-allowed"
          : "bg-blue-600 hover:bg-blue-700"
      }`}
      disabled={layoutData.inCart?.includes(product._id) || product.pQuantity === 0 || !selectedShipping}
    >
      {!selectedShipping 
        ? "Selecione o frete primeiro"
        : layoutData.inCart?.includes(product._id)
          ? "✓ Adicionado ao carrinho"
          : product.pQuantity > 0
            ? `Adicionar ao carrinho`
            : "Indisponível"}
    </button>
  </div>
)}
            </div>
          </div>
        </div>
      </section>

      <ProductDetailsSectionTwo />
    </Fragment>
  );
};

export default ProductDetailsSection;